import { InjectionToken } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { Messaging, getMessaging } from 'firebase/messaging';
import { environment } from 'src/environments/environment';

/**
 * Firebase Cloud Messaging instance used for web push (the only Firebase feature of the app).
 *
 * Created lazily on first injection, i.e. after `PushService` has confirmed `isSupported()`, so
 * unsupported browsers never initialise Firebase. Replaces `@angular/fire`'s `provideFirebaseApp()` /
 * `provideMessaging()`, whose release cadence lags behind Angular majors.
 */
export const FIREBASE_MESSAGING = new InjectionToken<Messaging>('FIREBASE_MESSAGING', {
  providedIn: 'root',
  factory: () => getMessaging(initializeApp(environment.firebase)),
});
